/**
 * Created by lu on 2018/4/24.
 */
var language = {
    cn: {
        products: {
            title: '商品推荐',
            titleEn: 'Product Recommondation'
        },
        register: {
            title: '采购流程',
            titleEn: 'Purchasing Process',
            tit1: '如有疑问，请点击',
            tit2: '采购流程',
            tit3: '查看相关信息'
        },
        typeList: {
            title: '酒类推荐',
            titleEn: 'Wine Recommondation',

        },
        brandList: {
            brandTitle: '品牌推荐',
            brandTitleEn: 'Brand Recommondation'
        },
        bottom: {
            title: '“ASC—中国精品葡萄酒进口行业的翘楚”',
            placeholder: '想要收到ASC的信息，请留下您的电邮地址',
            btnRegister: '提交',
            emailToast1: '请填写邮箱！',
            emailToast2: '请填写有效邮箱！！'
        }
    },
    en: {
        products: {
            title: '商品推荐',
            titleEn: 'Product Recommondation'
        },
        register: {
            title: '采购流程',
            titleEn: 'Purchasing Process',
            tit1: 'If you have any queries, please click ',
            tit2: 'the purchasing process',
            tit3: ''
        },
        typeList: {
            title: '酒类推荐',
            titleEn: 'Wine Recommondation'
        },
        brandList: {
            brandTitle: '品牌推荐',
            brandTitleEn: 'Brand Recommondation'
        },
        bottom: {
            title: '“ASC Fine Wines，the greatest fine wine importer of China.”',
            placeholder: 'Leave email to receive ASC information.',
            btnRegister: 'Submit',
            emailToast1: 'Please fill in the mailbox！',
            emailToast2: 'Please fill in the valid mailbox！！'
        }
    }
};
module.exports = {
    language: language
};



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/config.js
// module id = 540
// module chunks = 6